import AnimationClip from '../AnimationClip';
import Armature from '../../../Prototype/Armature';
import DragonbonesComponent from '../../../Component/Dragonbones';

export class DragonbonesFadeIn extends AnimationClip {
    public *execute(
        gameObject: Armature,
        meta?: {
            animationName?: string;
            progress?: number;
            fadeInTime?: number;
        }
    ): IterableIterator<number> {
        if (!meta) meta = {};
        meta.progress = meta.progress || 0;
        meta.animationName = meta.animationName || 'animation';
        meta.fadeInTime = meta.fadeInTime || 1;

        gameObject.getComponent(DragonbonesComponent).animationName =
            meta.animationName;

        gameObject.container.visible = true;
        gameObject.container.animation.fadeIn(
            meta.animationName,
            meta.fadeInTime,
            -1
        );

        let complete = false;
        const onComplete = () => {
            complete = true;
            gameObject.container.removeDBEventListener(
                'complete',
                onComplete,
                gameObject.container
            );
        };

        gameObject.container.addDBEventListener(
            'complete',
            onComplete,
            gameObject.container
        );

        while (!complete) {
            yield;
        }
    }
}
